/* Optional selection helpers and current-page attribution. No remote requests. */
(() => {
  /** @param {HTMLElement} root S1 section */
  const setup = (root) => {
    if (root.dataset.lqReady) return;
    root.dataset.lqReady = 'true';
    const params = new URLSearchParams(window.location.search);
    const values = [];
    for (const key of ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']) {
      const value = params.get(key);
      if (value) values.push(`${key}=${value.replace(/[\u0000-\u001f\u007f]/g, '').slice(0,160)}`);
    }
    for (const field of root.querySelectorAll('[data-lq-attribution]')) field.value = values.join(' | ') || 'Not supplied';
    const configuration = root.querySelector('[name="contact[Configuration]"]');
    const finish = root.querySelector('[name="contact[Finish]"]');
    const intent = root.querySelector('[name="contact[Inquiry type]"]');
    const extra = root.querySelector('[data-lq-cartridge-count]');
    const selection = root.querySelector('[data-lq-selection]');
    const update = () => {
      const chosen = [];
      for (const field of [configuration, finish]) {
        if (field.value !== 'Not decided') chosen.push(field.selectedOptions[0].textContent);
      }
      const showExtra = configuration.value === 'Head + extra cartridges';
      extra.hidden = !showExtra;
      extra.querySelector('select').disabled = !showExtra;
      selection.textContent = `${root.dataset.selectionLabel} ` + chosen.join(' · ');
      selection.hidden = chosen.length === 0;
    };
    // The success response has no form fields.
    if (!configuration || !finish || !intent) return;
    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-lq-config], [data-lq-finish], [data-lq-intent]');
      if (!link) return;
      if (link.dataset.lqConfig) configuration.value = link.dataset.lqConfig;
      if (link.dataset.lqFinish) finish.value = link.dataset.lqFinish;
      intent.value = link.dataset.lqIntent || intent.value || 'Wholesale quote';
      update();
    });
    configuration.addEventListener('change',update);
    finish.addEventListener('change',update);
    update();
  };
  const init = (container) => {
    for (const root of container.querySelectorAll('[data-lq-s1]')) setup(root);
  };
  init(document);
  if (!window.lqS1SectionListener) {
    document.addEventListener('shopify:section:load', event => init(event.target));
    window.lqS1SectionListener = true;
  }
})();
